import { CSSProperties } from 'react';
import { Theme } from '@mui/material';
import { Colors } from "../../../utils/theme";

export const aboutPageStyles = (theme: Theme, showMoreTestimonials) => ({
	root: {},
	heroBackground: {
		width: '100%',
		height: '100%',
		objectFit: 'cover',
		objectPosition: 'top center',
		pointerEvents: 'none',
	} as CSSProperties,
	heroText: {
		fontFamily: 'Integral CF',
		fontSize: { xs: '24px', sm: '28px', md: '35px', lg: '42px' },
		color: 'white',
		textAlign: 'center',
	},
	aboutTitleWrapper: {
		display: 'flex',
		flexFlow: 'column nowrap',
		px: { xs: '20px', md: '60px', lg: '90px' },
		pt: { xs: '90px', md: '128px' },
		pb: { xs: '120px', md: '150px' },
	},
	aboutSmallerText: {
		color: '#321AF1',
		fontFamily: 'Integral CF',
		fontStyle: 'italic',
		lineHeight: '1.2em',
		textTransform: 'uppercase',
		pl: { xs: '8px', md: '20px' },
	},
	aboutTitle: {
		fontFamily: 'Integral CF',
		fontStyle: 'italic',
		fontWeight: '700',
		fontSize: { xs: '32px', sm: '42px', md: '62px', lg: '72px', xl: '92px' },
		textTransform: 'uppercase',
	},
	aboutTextWrapper: {
		display: 'flex',
		flexFlow: 'column nowrap',
		gap: '100px',
		backgroundColor: '#120E0D',
		px: { xs: '20px', sm: '60px', md: '90px', lg: '110px' },
		py: { xs: '90px', sm: '110px', md: '130px', lg: '140px' },
	},
	aboutTextRow: {
		display: 'flex',
		alignItems: 'center',
		flexFlow: { xs: 'column nowrap', md: 'row nowrap' },
		gap: '40px',

		color: 'white',
		fontFamily: 'Montserrat',
		fontWeight: '500',
		fontSize: { xs: '16px' },
		lineHeight: { xs: '27px' },
	},
	aboutBoldText: {
		fontFamily: 'Integral CF',
		fontStyle: 'italic',
	},
	valuesWrapper: {
		display: 'flex',
		flexFlow: 'column nowrap',
		px: { xs: '20px', md: '60px' },
		py: { xs: '80px', md: '110px' },
		gap: '80px',
	},
	valuesTitle: {
		fontFamily: 'Integral CF',
		fontStyle: 'italic',
		fontWeight: '500',
		fontSize: { xs: '24px', md: '30px', lg: '42px', },
		textTransform: 'uppercase',
	},
	valuesItem: {
		display: 'flex',
		flexFlow: 'column nowrap',
		gap: '12px',
	},
	valuesItemHeaderWrapper: {
		display: 'flex',
		flexFlow: 'column nowrap',
		gap: '8px',
	},
	valueItemTitle1: {
		fontFamily: 'Integral CF',
		fontWeight: '500',
		fontStyle: 'italic',
		fontSize: '32px',
	},
	valueItemTitle2: {
		fontFamily: 'Integral CF',
		fontWeight: '500',
		fontStyle: 'italic',
		fontSize: '24px',
	},
	valueItemText: {
		fontFamily: 'Montserrat',
		fontWeight: '500',
	},
	statsWrapper: {
		p: { xs: '0px', md: '60px' },
	},
	statsContent: {
		display: 'flex',
		flexFlow: 'row nowrap',
	},
	statsLeftSide: {
		display: 'flex',
		flexFlow: 'column nowrap',
		gap: { xs: '20px', md: '30px', lg: '40px' },
		backgroundColor: '#FFF521',
		p: '60px 50px',
		maxWidth: {
			xs: '100%',
			md: '20%',
		},
		width: '100%',
	},
	statsRightSide: {
		flexGrow: '1',
		backgroundImage: 'url("/assets/images/stats-image.webp")',
		backgroundSize: 'cover',
		backgroundPosition: 'center',
	},
	statsItem: {
		display: 'flex',
		flexFlow: 'column nowrap',
		gap: '8px',
	},
	statsItemNumber: {
		fontFamily: 'Integral CF',
		fontStyle: 'italic',
		fontSize: '44px',
		lineHeight: '1.2em',
	},
	statsItemTitle: {
		fontFamily: 'Integral CF',
		fontSize: '18px',
		lineHeight: '1.2em',
	},
	testimonialsWrapper: {
		height: showMoreTestimonials ? undefined : 1200,
		position: 'relative',
		overflowY: 'hidden',
		boxSizing: 'border-box',
		'-ms-overflow-style': 'none',
		'scrollbarWidth': 'none',
		'&::-webkit-scrollbar': {
			display: 'none',
		},
	},
	testimonialsBottomShadow: {
		display: showMoreTestimonials ? 'none' : 'block',
		background: 'linear-gradient(180deg, rgba(255, 255, 255, 0.00) 0%, #FFF 100%)',
		position: 'sticky',
		bottom: 0,
		height: '120px',
	},
	growInvestWrapper: {
		pl: 13,
		pr: 11,
		pt: 8,
		gap: 4,
		flex: 1,
	},
	leadTheChargeText: {
		color: 'white',
		textAlign: 'center',
		fontFamily: 'Integral CF',
		fontSize: '32px',
		fontStyle: 'normal',
		fontWeight: '700',
		lineHeight: 'normal',
		textTransform: 'uppercase',
	},
	growCommunityButton: {
		width: '100%',
		background: Colors['FFF521'],
	},
	investInSweatPalsButton: {
		width: '100%'
	},
});
